export default "__VITE_ASSET__DH6OU6Um__"